/** @module csi/task/TaskDueDateRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/UniversalDate",
	"csi/types",
	"./TaskDueDateOrPriorityAction",
	"./util"
], function(declare, UniversalDate, types, TaskDueDateOrPriorityAction, TaskUtil) {

	return declare(UniversalDate, {
		bTestFormat: true,

		/**
		 * @override
		 * Use a special action to disable editing if not Assignee
		 */
		_getAction: function() {
			return new TaskDueDateOrPriorityAction();
		},

		/**
		 * @override
		 * Render due date relative to todays date
		 */
		formatValue: function(value, fmt) {
			return value ? types.getFormattedDateDifference(types.getTimeDate(value, fmt)) : "";
		},

		/**
		 * @override
		 * Add CSS class to indicate if task is overdue or upcoming
		 */
		_getRenderCSS: function(ctx, h) {
			const value = this._getValue(ctx, h);
			const dt = value ? types.getTimeDate(value, h.m_format) : null;
			const classification = TaskUtil.getDueDateClassification(dt, true);
			return this.inherited(arguments) + " csi-camunda-task-due-" + classification;
		}
	});
});
